(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-gallery"] && !Shopify.designMode) return;
  try {
    
  window.ArticleListComponent = function () {
    return {
      init: function () {
        const swiper = new Swiper(this.$refs.swiperWrapper, {
          breakpoints: {
            640: {
              slidesPerView: 3,
              spaceBetween: 5,
            },
          },
          slidesPerView: 1.4,
          spaceBetween: 10,
          scrollbar: {
            el: this.$refs.swiperScrollbar,
            draggable: true,
            snapOnRelease: false,
          },
          freeMode: true,
          mousewheel: {
            forceToAxis: true,
          },
        });

        const prevButtons = this.$el.querySelectorAll('[data-navigation-button="prev"]');
        const nextButtons = this.$el.querySelectorAll('[data-navigation-button="next"]');

        prevButtons.forEach((button) => {
          button.addEventListener('click', () => {
            swiper.slidePrev();
          });
        });

        nextButtons.forEach((button) => {
          button.addEventListener('click', () => {
            swiper.slideNext();
          });
        });
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-items"] && !Shopify.designMode) return;
  try {
    
  window.CartComponent = function (discount) {
    return {
      discountCode: '',
      isApplyingDiscount: false,
      isApplyDiscountSuccess: false,
      isApplyDiscountError: false,
      applyDiscountErrorMessage: '',
      // remove discount
      removeDiscountMutation: null,
      isRemovingDiscount: false,
      isRemovingDiscountSuccess: false,
      isRemovingDiscountError: false,
      removeDiscountErrorMessage: '',
      // shipping estimator
      shippingRates: [],
      get minimumShippingRate() {
        if (!this.shippingRates.length) {
          return null;
        }
        return this.shippingRates.reduce((min, rate) => (rate.price < min.price ? rate : min), this.shippingRates[0]);
      },
      get estimatedHandlingShipping() {
        const shippingRate = this.minimumShippingRate;
        console.log('shippingRate', shippingRate);
        if (!shippingRate) {
          return null;
        }
        if (shippingRate.price === 0) {
          return 'Free';
        }

        // shipping rate is using the shop's default currency, convert to the current currency
        const isCurrencyCodeTheSame = shippingRate.currency === window.Shopify.currency.active;
        const price = isCurrencyCodeTheSame ? shippingRate.price : shippingRate.price * window.Shopify.currency.rate;
        return new Intl.NumberFormat(window.Shopify.locale, {
          style: 'currency',
          currency: window.Shopify.currency.active,
        }).format(price);
      },
      get estimatedDeliveryDate() {
        const shippingRate = this.minimumShippingRate;
        if (!shippingRate?.delivery_date) {
          return null;
        }
        return new Date(shippingRate.delivery_date).toLocaleDateString(window.Shopify.locale, {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        });
      },
      applyDiscount: function (discountCode) {
        if (!discountCode) {
          return;
        }
        if (!this.$store.cart.data.discount_codes.map((code) => code.code).includes(discountCode)) {
          this.isApplyingDiscount = true;
          this.isApplyingDiscountError = false;
          this.applyDiscountErrorMessage = '';
          this.isApplyingDiscountSuccess = false;
          this.$store.cart.updateCartMutation.mutate(
            {
              discount: [...this.$store.cart.data.discount_codes.map((code) => code.code), discountCode].join(','),
            },
            {
              onSuccess: (data) => {
                this.isApplyingDiscountSuccess = true;
                this.$store.cart.data = data;
                this.discountCode = '';
              },
              onError: (error) => {
                this.isApplyingDiscountError = true;
                this.applyDiscountErrorMessage = error.message;
              },
              onSettled: () => {
                this.isApplyingDiscount = false;
              },
            }
          );
        }
      },
      removeDiscount: function (discountCode) {
        if (this.$store.cart.data.discount_codes.map((code) => code.code).includes(discountCode)) {
          this.isRemovingDiscount = true;
          this.isRemovingDiscountError = false;
          this.removeDiscountErrorMessage = '';
          this.isRemovingDiscountSuccess = false;
          this.$store.cart.updateCartMutation.mutate(
            {
              discount: this.$store.cart.data.discount_codes
                .filter((code) => code.code !== discountCode)
                .map((code) => code.code)
                .join(','),
            },
            {
              onSuccess: (data) => {
                this.isRemovingDiscountSuccess = true;
                this.$store.cart.data = data;
              },
              onError: (error) => {
                this.isRemovingDiscountError = true;
                this.removeDiscountErrorMessage = error.message;
              },
              onSettled: () => {
                this.isRemovingDiscount = false;
              },
            }
          );
        }
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["communication-settings-section"] && !Shopify.designMode) return;
  try {
    
  window.CommunicationSettingsSectionComponent = function () {
    return {
      activeMenuItem: 'communication_settings',
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-activities"] && !Shopify.designMode) return;
  try {
    
  window.FeaturedActivitiesComponent = function () {
    return {
      mouseXPercent: 0,
      scrollPercent: 0,
      translateXRange: 0,
      scaleFactor: 0.2,
      hoveredItemIndex: null,
      hoverTimeout: null,
      titlesData: [],
      activeScale: 2,
      activeMobileIndex: null,
      swiperInstance: null,
      init() {
        this.$nextTick(() => {
          this.onScroll();
          const titles = this.$refs.row.querySelectorAll('a');
          titles.forEach((el, i) => {
            this.titlesData.push({ width: el.offsetWidth });
          });
        });

        const detectActive = (swiper) => {
          if (window.innerWidth >= 640) {
            this.activeMobileIndex = null;
            return;
          }
          const containerMid = swiper.el.offsetWidth / 2;
          let closestIndex = 0;
          let closestDist = Infinity;
          swiper.slides.forEach((slide, i) => {
            const slideCenter = slide.offsetLeft + swiper.translate + slide.offsetWidth / 2;
            const dist = Math.abs(slideCenter - containerMid);
            if (dist < closestDist) {
              closestDist = dist;
              closestIndex = i;
            }
          });
          this.activeMobileIndex = closestIndex;
        };

        this.swiperInstance = new Swiper(this.$refs.rowContainerMobile, {
          slidesPerView: 2.5,
          centeredSlides: true,
          spaceBetween: 15,
          freeMode: true,
          mousewheel: {
            forceToAxis: true,
          },
          on: {
            afterInit: detectActive,
            progress: detectActive,
          },
        });

        this.$watch('$store.breakpoints.isMobile', (isMobile) => {
          if (isMobile) {
            this.$nextTick(() => {
              this.swiperInstance.update();
              detectActive(this.swiperInstance);
            });
          } else {
            this.activeMobileIndex = null;
          }
        });

        if (!Alpine.store('breakpoints').isMobile) {
          this.activeMobileIndex = null;
        }
      },
      onScroll() {
        const rect = this.$refs.container.getBoundingClientRect();
        const vh = window.innerHeight;

        // Start zoom when section top is at 75% of viewport
        const startPoint = vh * 0.75;
        // End zoom when section bottom hits the bottom of viewport
        const endPoint = vh - rect.height;

        let p = (startPoint - rect.top) / (startPoint - endPoint);
        this.scrollPercent = Math.max(0, Math.min(1, p));
      },
      onHover(index) {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        this.hoverTimeout = setTimeout(() => {
          this.hoveredItemIndex = index;
        }, 30); // 30ms debounce for smoother intent
      },
      getStyle(index) {
        if (this.hoveredItemIndex === null || this.titlesData.length === 0) {
          return { transform: 'translateX(0) scale(1)' };
        }

        const isHovered = this.hoveredItemIndex === index;
        const scale = isHovered ? this.activeScale : 1;

        let tx = 0;
        const hoveredWidth = this.titlesData[this.hoveredItemIndex].width;
        // Calculate the extra width added by the scale
        const extraWidth = (hoveredWidth * this.activeScale - hoveredWidth) / 2;

        // Shift neighbors left/right based on the hovered item
        if (index < this.hoveredItemIndex) {
          tx = -extraWidth;
        } else if (index > this.hoveredItemIndex) {
          tx = extraWidth;
        }

        return {
          transform: `translateX(${tx}px) scale(${scale})`,
          zIndex: isHovered ? 20 : 10,
          pointerEvents: 'auto',
        };
      },
      onMouseMove(e) {
        const rowContainerWidth = this.$refs.rowContainer.getBoundingClientRect().width;
        const rect = this.$refs.container.getBoundingClientRect();

        const widthDifference = rowContainerWidth - rect.width;
        this.translateXRange = widthDifference / 2 + window.innerWidth * 0.2;

        const xPos = e.clientX / window.innerWidth;
        // Normalize mouse position to range [-1, 1] and apply user's 0.25 multiplier
        this.mouseXPercent = (xPos - 0.5) * 0.25;
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-pages"] && !Shopify.designMode) return;
  try {
    
  window.PageListComponent = function () {
    return {
      init: function () {
        const swiper = new Swiper(this.$refs.swiperWrapper, {
          slidesPerView: 1.2,
          spaceBetween: 10,
          scrollbar: {
            el: this.$refs.swiperScrollbar,
            draggable: true,
            snapOnRelease: false,
          },
          freeMode: true,
          mousewheel: {
            forceToAxis: true,
          },
        });

        const prevButtons = this.$el.querySelectorAll('[data-navigation-button="prev"]');
        const nextButtons = this.$el.querySelectorAll('[data-navigation-button="next"]');

        prevButtons.forEach((button) => {
          button.addEventListener('click', () => {
            swiper.slidePrev();
          });
        });

        nextButtons.forEach((button) => {
          button.addEventListener('click', () => {
            swiper.slideNext();
          });
        });
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  window.FooterComponent = function () {
    return {
      init: function () {
        const benefits = this.$refs.benefitsSwiper.querySelectorAll('.swiper-slide');
        const numBenefits = benefits.length;
        const shouldLoop = numBenefits > 3;
        new Swiper(this.$refs.benefitsSwiper, {
          breakpoints: {
            640: {
              slidesPerView: 3,
            },
          },
          slidesPerView: 1,
          allowTouchMove: false,
          loop: shouldLoop,
          autoplay: {
            enabled: shouldLoop,
            delay: 4000,
            disableOnInteraction: false,
          },
          speed: 1000,
        });
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  window.HeaderComponent = function () {
    return {
      secondaryNavigationFixed: false,
      headerTranslateY: 0,
      init: function () {
        const header = this.$refs.header;
        const primaryNavigation = this.$refs.primaryNavigation;
        const secondaryNavigation = this.$refs.secondaryNavigation;
        const secondaryNavigationContainer = this.$refs.secondaryNavigationContainer;

        if (primaryNavigation) {
          const primaryNavigationLinks = primaryNavigation.querySelectorAll('a');
          primaryNavigationLinks.forEach((link) => {
            const isActive = link.href === window.location.href;
            link.classList.toggle('!text-summit-yellow', isActive);
          });
        }

        const secondaryNavigationHeight = secondaryNavigation.getBoundingClientRect().height;
        secondaryNavigationContainer.style.height = `${secondaryNavigationHeight}px`;
        document.documentElement.style.setProperty('--secondary-navigation-height', `${secondaryNavigationHeight}px`);
        const headerHeight = header.getBoundingClientRect().height;
        const primaryNavigationHeight = this.$refs.primaryNavigationContainer.getBoundingClientRect().height;
        document.body.style.setProperty('--header-height', `${headerHeight}px`);

        const onScroll = (progress, info) => {
          if (secondaryNavigationContainer.getBoundingClientRect().top < 0) {
            this.secondaryNavigationFixed = true;
          } else {
            this.secondaryNavigationFixed = false;
          }

          const headerTop = header.getBoundingClientRect().top;
          const currentPrimaryNavigationHeight = Math.max(primaryNavigationHeight + headerTop, 0);
          document.body.style.setProperty('--current-primary-navigation-height', `${currentPrimaryNavigationHeight}px`);
          const currentHeaderHeight = Math.max(headerHeight + headerTop, secondaryNavigationHeight);
          document.body.style.setProperty('--current-header-height', `${currentHeaderHeight}px`);

          // scroll up if there is a row filter (Like in a collection page)
          if (
            this.$store.hasRowFilter &&
            info.y.current + secondaryNavigationHeight > this.$store.distanceFromRowFilterTopToPageTop
          ) {
            this.headerTranslateY = -(
              info.y.current +
              secondaryNavigationHeight -
              this.$store.distanceFromRowFilterTopToPageTop
            );
          } else {
            this.headerTranslateY = 0;
          }
        };

        Motion.scroll(onScroll);
        onScroll();

        const onResize = () => {
          const secondaryNavigationContent = this.$refs.secondaryNavigationContent;
          const secondaryNavigationContentRect = secondaryNavigationContent.getBoundingClientRect();
          document.documentElement.style.setProperty(
            '--secondary-navigation-left',
            `${secondaryNavigationContentRect.left}px`
          );
        };

        window.addEventListener('resize', onResize);
        onResize();

        this.$watch('$store.breakpoints.isMobile', (value, oldValue) => {
          if (value === oldValue) return;
          if (value) {
            this.$store.settings.disableBodyScrollLock();
          }
        });
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-tracking-detail"]) return;
  try {
    
  window.OrderTrackingDetailComponent = function (includingTaxesText, _email, _orderNumber) {
    return {
      errorMessage: '',
      isPending: false,
      isSuccess: false,
      isError: false,
      validator: null,
      mutation: null,
      order: null,
      init() {
        const searchParams = new URLSearchParams(window.location.search);
        const orderNumber = _orderNumber || searchParams.get('order-number');
        const email = _email || searchParams.get('email');

        window.query({
          key: ['order-tracking-detail', orderNumber, email],
          fn: () => this.getOrder(orderNumber, email),
          subscribeFn: (result) => {
            this.isPending = result.isPending;
            this.isSuccess = result.isSuccess;
            this.isError = result.isError;
            this.errorMessage = result.error;
            if (result.isSuccess) {
              this.order = result.data;
            }
          },
        });
      },
      async getOrder(orderNumber, email) {
        const response = await fetch(
          `${window.Shopify.routes.root}apps/api/order?email=${email}&order-number=${orderNumber}`
        );
        if (!response.ok) {
          if (response.status === 404) {
            throw new Error('Order not found');
          }
          throw new Error('Failed to get order');
        }
        const data = await response.json();
        return data.order;
      },
      displayPrice(price) {
        return new Intl.NumberFormat(window.Shopify.locale, { style: 'currency', currency: price.currencyCode }).format(
          price.amount
        );
      },
      displayIncludingTaxesText(taxAmount) {
        return includingTaxesText.replace('{ tax_amount }', this.displayPrice(taxAmount));
      },
      formatDate(date) {
        return new Date(date).toLocaleDateString(window.Shopify.locale, {
          month: 'long',
          day: 'numeric',
        });
      },
      get buyAgainUrl() {
        const cartQuery = this.order.lineItems.edges
          .map((item) => `${item.node.variant.id.replace('gid://shopify/ProductVariant/', '')}:${item.node.quantity}`)
          .join(',');
        return `${window.Shopify.routes.root}cart/${cartQuery}`;
      },
      getFulfillmentStatusDate(fulfillment) {
        if (fulfillment.deliveryStatus === 'Delivered') {
          return fulfillment.deliveredAt;
        }
        if (fulfillment.deliveryStatus === 'In transit') {
          return fulfillment.inTransitAt;
        }
        return fulfillment.updatedAt;
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-tracking"] && !Shopify.designMode) return;
  try {
    
  window.OrderTrackingComponent = function (orderDetailsPageURL) {
    return {
      email: '',
      orderNumber: '',
      errorMessage: '',
      validator: null,
      init() {
        this.validator = new JustValidate(this.$refs.form, {
          errorLabelStyle: {
            display: 'none',
          },
        });
        this.validator.addField('#email', [
          {
            rule: 'required',
            errorMessage: 'Email is required',
          },
          {
            rule: 'email',
            errorMessage: 'Invalid email',
          },
        ]);

        this.validator.addField('#orderNumber', [
          {
            rule: 'required',
            errorMessage: 'Order number is required',
          },
        ]);

        this.validator.onFail((errors) => {
          this.errorMessage = Object.values(errors)
            .map((error) => error.errorMessage)
            .join(', ');
        });

        this.validator.onSuccess(() => {
          window.location.href = `${orderDetailsPageURL}?email=${this.email}&order-number=${this.orderNumber.replace(
            '#',
            ''
          )}`;
        });
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  window.UnderConstructionPageEmailSubscriptionSnippetComponent = function () {
    return {
      isConsentChecked: false,
      email: '',
      mutation: null,
      isPending: false,
      isSuccess: false,
      isError: false,
      errorMessage: '',
      klaviyoListIdForUnderConstructionPageSubscription: '',
      init: function () {
        this.klaviyoListIdForUnderConstructionPageSubscription =
          this.$root.dataset.klaviyoListIdForUnderConstructionPageSubscription;

        const mutation = window.createMutation({
          mutationFn: () =>
            this.subscribeToList({
              subscriptionType: 'email',
              email: this.email,
              listId: this.klaviyoListIdForUnderConstructionPageSubscription,
            }),
          subscribeFn: (result) => {
            this.isPending = result.isPending;
            this.isSuccess = result.isSuccess;
            this.isError = result.isError;
            this.errorMessage = result.error;

            if (this.isSuccess) {
              this.email = '';
            }
          },
        });
        this.mutation = mutation;
      },
      destroy() {
        this.mutation.unsubscribe();
      },
      onSubmit: function (e) {
        e.preventDefault();
        this.mutation.mutate();
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-categories"] && !Shopify.designMode) return;
  try {
    
  window.ProductCategoriesComponent = function () {
    return {
      activeCategory: null,
      panelSwiperInitialized: false,
      init: function () {
        const swiper = new Swiper(this.$refs.swiper, {
          slidesPerView: 1.3,
          freeMode: true,
          breakpoints: {
            640: { slidesPerView: 3.1 },
          },
          mousewheel: {
            forceToAxis: true,
          },
        });

        // Make the peek button sticky to the bottom until reaching the title when scrolling down
        Motion.scroll((progress, info) => {
          const containerTop = this.$el.getBoundingClientRect().top;
          if (containerTop > 0) return;

          const titleEl = this.$el.querySelector('[data-title]');
          const peekButtonContainerEl = this.$el.querySelector('[data-peek-button-container]');
          if (!titleEl || !peekButtonContainerEl) return;
          const distanceFromPeekButtonToTitle =
            peekButtonContainerEl.getBoundingClientRect().top - titleEl.getBoundingClientRect().bottom;

          if (containerTop < -1 * distanceFromPeekButtonToTitle + 10) return;
          const buttons = this.$el.querySelectorAll('[data-peek-button]');
          buttons.forEach((button) => {
            const buttonTop = button.getBoundingClientRect().top;
            button.style.transform = `translateY(${containerTop}px)`;
          });
        });
      },
      openCategory(category) {
        this.activeCategory = category;
        if (!this.panelSwiperInitialized) {
          const panelSwiperEls = document.querySelectorAll('[data-product-categories-panel-swiper]');
          panelSwiperEls.forEach((swiperContainerEl) => {
            const swiperEl = swiperContainerEl.querySelector('.swiper');
            const prevButtonEl = swiperContainerEl.querySelector('[data-navigation-button="prev"]');
            const nextButtonEl = swiperContainerEl.querySelector('[data-navigation-button="next"]');
            const swiper = new Swiper(swiperEl, {
              slidesPerView: 2.2,
              spaceBetween: 5,
              slidesOffsetBefore: 15,
              slidesOffsetAfter: 15,
              breakpoints: {
                640: { slidesPerView: 1.9, slidesOffsetBefore: 45, slidesOffsetAfter: 45 },
              },
              freeMode: true,
              mousewheel: {
                forceToAxis: true,
              },
            });

            prevButtonEl.addEventListener('click', () => {
              swiper.slidePrev();
            });
            nextButtonEl.addEventListener('click', () => {
              swiper.slideNext();
            });
          });
          this.panelSwiperInitialized = true;
        }
      },
      closePanel() {
        this.activeCategory = null;
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-gallery"] && !Shopify.designMode) return;
  try {
    
  window.ProductGalleryComponent = function ({ hasProductHero }) {
    return {
      showVariantImage: false,
      activeImage: null,
      mobileSwiper: null,
      mobileVariantImageAnimation: null,
      init: function () {
        const slideCount = this.$refs.gallerySwiperContainer.querySelectorAll('.swiper-slide').length;
        this.mobileSwiper = new Swiper(this.$refs.gallerySwiperContainer, {
          slidesPerView: slideCount <= 1 ? 1 : 1.2,
          spaceBetween: 5,
          freeMode: true,
          mousewheel: {
            forceToAxis: true,
          },
        });

        this.$watch('$store.product.selectedVariant', (variant) => {
          if (variant) {
            if (this.$store.breakpoints.isMobile) {
              // mobile variant image animation
              const selectedVariantMediaID = String(variant.featured_media?.id ?? variant.featured_image?.id ?? '');
              if (!selectedVariantMediaID) return;
              const slides = this.mobileSwiper.slides;
              const selectedVariantImageSlide = slides.find((slide) => slide.id === selectedVariantMediaID);
              const selectedVariantImageSlideIndex = selectedVariantImageSlide
                ? this.mobileSwiper.slides.indexOf(selectedVariantImageSlide)
                : -1;

              if (selectedVariantImageSlideIndex !== -1) {
                this.mobileSwiper.slideTo(selectedVariantImageSlideIndex);
                for (const slide of slides) {
                  slide.children[0]?.classList?.remove?.('!border-black/60');
                }
                selectedVariantImageSlide.children[0]?.classList?.add?.('!border-black/60');
              }
            } else {
              // desktop variant image animation
              if (!this.showVariantImage) {
                this.showVariantImage = true;
                this.$store.product.showPersonalizationInput = false;
                this.$root.scrollIntoView({ behavior: 'auto' });
                const galleryContainerWidth = this.$refs.galleryContainer.getBoundingClientRect().width;
                const variantImageAspectRatio = variant.featured_image.width / variant.featured_image.height;
                const variantImageContainerHeight = galleryContainerWidth / variantImageAspectRatio;
                Motion.animate(
                  this.$refs.galleryContainer,
                  {
                    height: variantImageContainerHeight,
                  },
                  {
                    duration: 0.15,
                    ease: 'easeOut',
                  }
                ).then(() => {
                  this.$refs.galleryContainer.style.height = 'auto';
                  this.$refs.variantImageContainer.style.position = 'static';
                });
              }
            }
          }
        });

        window.addEventListener('resize', () => {
          if (this.$store.breakpoints.isMobile) {
            this.showVariantImage = false;
          }
        });

        this.$watch('activeImage', (image) => {
          if (image) {
            this.$store.settings.enableBodyScrollLock();
          } else {
            this.$store.settings.disableBodyScrollLock();
          }
        });
      },
      get variantImageSrc() {
        return this.showVariantImage && this.$store.product.selectedVariant
          ? this.$store.product.selectedVariant.featured_image.src
          : undefined;
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-listing"] && !Shopify.designMode) return;
  try {
    
  window.CategoryListingComponent = function (productsCount, rowFilterLabel, showRowFilter, showProductFinder) {
    return {
      rowFilterLabel: rowFilterLabel,
      numberOfProducts: productsCount,
      isFiltersOpen: false,
      isFilteredProductGridOpen: false,
      sortBy: null,
      // These are the unapplied sort by used on mobile when the user changes sort by but not apply them yet.
      unappliedSortBy: null,
      filters: [],
      // These are the unapplied filter values used on mobile when the user changes filters but not apply them yet.
      unappliedFilters: [],
      filterParamNames: [],
      isCompareOpen: false,
      isFinderOpen: false,
      // filter result
      fetchFilterResultMutation: null,
      newFilterResult: null,
      isPending: false,
      isSuccess: true,
      isError: false,
      error: null,
      init() {
        // set the row filter data in the settings store
        this.$store.hasRowFilter = !!showRowFilter;
        const onResize = () => {
          this.$store.distanceFromRowFilterTopToPageTop =
            this.$refs.rowFilterPlaceholder.getBoundingClientRect().top -
            document.documentElement.getBoundingClientRect().top;
        };
        window.addEventListener('resize', onResize);
        onResize();

        const onScroll = () => {
          if (this.$store.hasRowFilter) {
            this.$store.settings.rowFilterStickyStarted =
              this.$refs.rowFilterPlaceholder.getBoundingClientRect().top < 0;
          }
        };
        Motion.scroll(onScroll);
        onScroll();

        // get the initial filter values
        this.getInitialFilters();

        // filter out featured products and product highlights, then correct the order of the email subscription card
        const emailSubscriptionCard = this.$root.querySelector('[data-email-subscription-card]');
        const featuredProductsCards = document.querySelectorAll('[data-product-featured-card-id]');
        const productHighlights = document.querySelectorAll('[data-product-highlight-id]');
        const featuredProductIds = new Set(
          [...(featuredProductsCards ?? []), ...(productHighlights ?? [])].map(
            (element) => element.dataset.productFeaturedCardId
          )
        );
        if (featuredProductIds) {
          let count = 0;
          Array.from(featuredProductIds).forEach((id) => {
            if (id) {
              const productCard = this.$refs.productGridContainer.querySelector(`[data-product-grid-item-id="${id}"]`);
              if (productCard) {
                productCard.style.display = 'none';
                count++;
              }
            }
          });

          if (emailSubscriptionCard && count > 0) {
            const order = parseInt(emailSubscriptionCard.dataset.order);
            if (Number.isInteger(order)) {
              const newOrder = order + count * 10;
              emailSubscriptionCard.style['--email-subscription-order'] = newOrder;
            }
          }
        }

        this.fetchFilterResultMutation = window.createMutation({
          mutationFn: async (onlySetUnappliedValues) => {
            const url = this.generateNewURL();
            const params = url.searchParams;
            params.set('sections', 'product-grid-section,filters-data-section');
            const response = await fetch(url);
            if (!response.ok) {
              throw new Error('Failed to applied filters');
            }
            return { data: await response.json(), onlySetUnappliedValues };
          },
          subscribeFn: (result, unsubscribe) => {
            this.newFilterResult = null;
            this.isPending = result.isPending;
            this.isSuccess = result.isSuccess;
            this.isError = result.isError;
            this.error = result.error;

            if (result.isSuccess) {
              const data = result.data.data;
              const onlySetUnappliedValues = result.data.onlySetUnappliedValues;
              this.getFiltersData(
                new DOMParser()
                  .parseFromString(data['filters-data-section'], 'text/html')
                  .querySelector('#filters-data'),
                onlySetUnappliedValues
              );
              if (!onlySetUnappliedValues) this.renderProductGrid(data);
            }
          },
        });

        this.$watch('$store.breakpoints.isMobile', (isMobile) => {
          if (!isMobile) {
            this.isFilteredProductGridOpen = this.hasAnyFilterActive();
            this.isFiltersOpen = this.hasAnyFilterActive(true);
          }
        });

        this.alignDesktopFilterAndSortAccordionsHeight();
      },
      alignDesktopFilterAndSortAccordionsHeight() {
        // align the desktop filter and sort accordions container's height with the desktop filter and sort accordions placeholder's height.
        const desktopFilterAndSortAccordionsContainer = this.$refs.desktopFilterAndSortAccordionsContainer;
        const desktopFilterAndSortAccordionsPlaceholder = this.$refs.desktopFilterAndSortAccordionsPlaceholder;
        const desktopFilterAndSortAccordionsPlaceholder2 = this.$refs.desktopFilterAndSortAccordionsPlaceholder2;
        const resizeObserver = new ResizeObserver((entries) => {
          const desktopFilterAndSortAccordionsContainerHeight = entries[0].contentRect.height;
          const desktopFilterAndSortAccordionsPlaceholderHeight =
            desktopFilterAndSortAccordionsPlaceholder.getBoundingClientRect().height;
          const desktopFilterAndSortAccordionsPlaceholder2Height =
            desktopFilterAndSortAccordionsPlaceholder2.getBoundingClientRect().height;
          if (desktopFilterAndSortAccordionsContainerHeight !== desktopFilterAndSortAccordionsPlaceholderHeight) {
            desktopFilterAndSortAccordionsPlaceholder.style.height = `${desktopFilterAndSortAccordionsContainerHeight}px`;
          }
          if (desktopFilterAndSortAccordionsContainerHeight !== desktopFilterAndSortAccordionsPlaceholder2Height) {
            desktopFilterAndSortAccordionsPlaceholder2.style.height = `${desktopFilterAndSortAccordionsContainerHeight}px`;
          }
        });
        resizeObserver.observe(desktopFilterAndSortAccordionsContainer);
      },
      // helper functions
      getFilter(filterValues, filterLabel) {
        if (!Array.isArray(filterValues)) return null;
        return filterValues.find((filter) => filter.label === filterLabel);
      },
      getFilterValue(filterValues, filterLabel, value) {
        return this.getFilter(filterValues, filterLabel)?.values.find((filterValue) => filterValue.value === value);
      },
      getFilterValueActiveStatus(filterValues, filterLabel, value) {
        return !!this.getFilterValue(filterValues, filterLabel, value)?.active;
      },
      isRowFilterLabel(filterLabel) {
        return (
          String(filterLabel ?? '')
            .trim()
            .toLowerCase() === this.rowFilterLabel
        );
      },
      getFilterTotalCount(filterLabel) {
        const targetFilterValues = this.$store.breakpoints.isMobile ? this.unappliedFilters : this.filters;
        return this.getFilter(targetFilterValues, filterLabel)?.values.reduce((total, value) => total + value.count, 0);
      },
      toggleFilterValueActiveStatus(filterValues, filterLabel, value) {
        const filterValue = this.getFilterValue(filterValues, filterLabel, value);
        if (filterValue?.active) {
          filterValue.active = false;
        } else {
          filterValue.active = true;
        }
      },
      // initialize the filter values and sort by
      getFiltersData(el, onlySetUnappliedValues = false) {
        if (el?.textContent) {
          try {
            const filtersData = JSON.parse(el.textContent);
            const parsedFilters = Array.isArray(filtersData.filters) ? filtersData.filters : [];
            const parsedSortBy = filtersData.sort_by ?? null;

            if (!onlySetUnappliedValues) {
              this.filters = parsedFilters;
              this.sortBy = parsedSortBy;
              this.unappliedFilters = structuredClone(Alpine.raw(this.filters));
              this.unappliedSortBy = this.sortBy;
            } else {
              // On mobile, keep applied values untouched and refresh only unapplied state.
              this.unappliedFilters = structuredClone(parsedFilters);
              this.unappliedSortBy = parsedSortBy;
            }
          } catch (error) {
            console.error('[ProductsListingComponent] Invalid filters data', error);
          }
        }
      },
      getInitialFilters() {
        const filtersDataEl = this.$root.querySelector('#filters-data');
        this.getFiltersData(filtersDataEl);

        const hasFiltersApplied = this.hasAnyFilterActive();
        const hasNonRowFiltersApplied = this.hasAnyFilterActive(true);
        if (hasFiltersApplied) {
          this.isFilteredProductGridOpen = true;
          if (!this.$store.breakpoints.isMobile && hasNonRowFiltersApplied) {
            this.isFiltersOpen = true;
          }
        }
      },
      onDesktopFilterButtonClick() {
        if (this.isFiltersOpen) {
          this.isFiltersOpen = false;
          this.isFilteredProductGridOpen = false;
          this.clearAllFilters();
        } else {
          this.isFiltersOpen = true;
          this.isFilteredProductGridOpen = true;
        }
      },
      onMobileFilterButtonClick() {
        this.isFiltersOpen = true;
      },
      getFilterValueCount(filterLabel, value) {
        const filterValue = parseInt(this.getFilterValue(this.filters, filterLabel, value)?.count);
        return parseInt(this.getFilterValue(this.filters, filterLabel, value)?.count) ?? 0;
      },
      getUnifiedFilterValueCount(filterLabel, value) {
        const targetFilterValues = this.$store.breakpoints.isMobile ? this.unappliedFilters : this.filters;
        return parseInt(this.getFilterValue(targetFilterValues, filterLabel, value)?.count) ?? 0;
      },
      isFilterValueActive(filterLabel, value) {
        return this.getFilterValue(this.filters, filterLabel, value)?.active;
      },
      isUnappliedFilterValueActive(filterLabel, value) {
        const targetFilterValues = this.$store.breakpoints.isMobile ? this.unappliedFilters : this.filters;
        return this.getFilterValueActiveStatus(targetFilterValues, filterLabel, value);
      },
      isUnifiedFilterValueActive(filterLabel, value) {
        const targetFilterValues = this.$store.breakpoints.isMobile ? this.unappliedFilters : this.filters;
        return this.getFilterValueActiveStatus(targetFilterValues, filterLabel, value);
      },
      hasAnyFilterActive(excludeRowFilter = false) {
        return (
          this.filters.some((filter) => {
            if (excludeRowFilter && this.isRowFilterLabel(filter.label)) return false;
            return filter.values.some((value) => value.active);
          }) || this.sortBy
        );
      },
      generateNewURL() {
        const newURL = new URL(window.location.href);
        const params = newURL.searchParams;
        const targetSortBy = this.$store.breakpoints.isMobile ? this.unappliedSortBy : this.sortBy;
        if (targetSortBy) {
          params.set('sort_by', targetSortBy);
        } else {
          params.delete('sort_by');
        }

        const targetFilterValues = this.$store.breakpoints.isMobile ? this.unappliedFilters : this.filters;
        targetFilterValues.forEach((filter) => {
          const values = filter?.values;
          const key = filter?.paramName;
          if (!key) return;
          params.delete(key);
          if (values?.length > 0) {
            values.forEach((value) => {
              if (value.active) {
                params.append(key, value.value);
              }
            });
          }
        });
        return newURL;
      },
      updateURL(newURL) {
        window.history.replaceState(null, '', newURL.toString());
      },
      renderProductGrid(result) {
        // render the product grid
        const html = new DOMParser()
          .parseFromString(result['product-grid-section'], 'text/html')
          .querySelector('#product-grid');
        const numberOfProducts = html.children.length;
        this.numberOfProducts = numberOfProducts;

        const container = this.$refs.categoryListingContainer.querySelector('#product-grid-container');
        container.innerHTML = '';
        container.appendChild(html);
      },
      onFilterChange(filterLabel, value) {
        this.toggleFilterValueActiveStatus(this.filters, filterLabel, value);
        // reset the unapplied filter values and sort by when the actual filter values are changed
        this.unappliedFilters = structuredClone(Alpine.raw(this.filters));
        this.unappliedSortBy = this.sortBy;

        this.updateURL(this.generateNewURL());

        this.fetchFilterResultMutation.mutate();
      },
      onUnappliedFilterChange(filterLabel, value) {
        this.toggleFilterValueActiveStatus(this.unappliedFilters, filterLabel, value);
        this.fetchFilterResultMutation.mutate(true);
      },
      onUnifiedFilterChange(filterLabel, value) {
        if (this.$store.breakpoints.isMobile) {
          this.onUnappliedFilterChange(filterLabel, value);
        } else {
          this.onFilterChange(filterLabel, value);
        }
      },
      isSortByValueActive(value) {
        const targetSortBy = this.$store.breakpoints.isMobile ? this.unappliedSortBy : this.sortBy;
        return targetSortBy === value;
      },
      onSortByChange(value, activeLabel) {
        if (this.$store.breakpoints.isMobile) {
          this.unappliedSortBy = value;
        } else {
          this.sortBy = value;
          // reset the unapplied sort by when the actual sort by is changed
          this.unappliedSortBy = value;
        }

        if (!this.$store.breakpoints.isMobile) this.updateURL(this.generateNewURL());

        this.fetchFilterResultMutation.mutate(this.$store.breakpoints.isMobile);
      },
      applyFilters() {
        this.filters = structuredClone(Alpine.raw(this.unappliedFilters));
        this.sortBy = this.unappliedSortBy;

        this.updateURL(this.generateNewURL());
        this.fetchFilterResultMutation.mutate();

        this.closeMobileFilterPanel();
      },
      closeMobileFilterPanel() {
        this.isFiltersOpen = false;
        if (!this.hasAnyFilterActive()) {
          this.isFilteredProductGridOpen = false;
        } else {
          this.isFilteredProductGridOpen = true;
        }
      },
      clearAllFilters() {
        if (!this.$store.breakpoints.isMobile) {
          this.sortBy = null;
          this.filters.forEach((filter) => {
            if (this.isRowFilterLabel(filter.label)) return;
            filter.values.forEach((value) => {
              value.active = false;
            });
          });
        }

        this.unappliedSortBy = null;
        this.unappliedFilters.forEach((filter) => {
          if (this.isRowFilterLabel(filter.label)) return;
          filter.values.forEach((value) => {
            value.active = false;
          });
        });

        if (!this.$store.breakpoints.isMobile) {
          this.updateURL(this.generateNewURL());
        }

        this.fetchFilterResultMutation.mutate(this.$store.breakpoints.isMobile);
      },
      get isPanelOpen() {
        return this.isFiltersOpen && this.$store.breakpoints.isMobile;
      },
      set isPanelOpen(value) {
        if (!value) this.closeMobileFilterPanel();
        else this.onMobileFilterButtonClick();
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  window.RecentlyViewedComponent = function () {
    return {
      init: async function () {
        const STORAGE_KEY = 'shopify-recently-viewed';
        const MAX_ITEMS = 6;
        const recentlyViewedContainer = this.$refs.recentlyViewedContainer;
        const currentProductHandle = recentlyViewedContainer.dataset.currentProductHandle;
        const listContainer = this.$refs.listContainer;
        const listContainerMobile = this.$refs.listContainerMobile;
        const swiperContainer = this.$refs.swiperContainer;
        let swiper = null;

        trackCurrentProduct();
        await displayRecentProducts();

        window.addEventListener('storage', async function (event) {
          if (event.key === STORAGE_KEY) {
            await displayRecentProducts();
          }
        });

        function getRecentHandles() {
          const storedValue = localStorage.getItem(STORAGE_KEY);
          try {
            return storedValue ? JSON.parse(storedValue) : [];
          } catch (error) {
            console.error('Error parsing recently viewed products:', error);
            return [];
          }
        }

        function saveRecentHandles(handles) {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
        }

        function trackCurrentProduct() {
          if (!currentProductHandle) {
            return; // Not a product page or handle is missing
          }

          let handles = getRecentHandles();
          // Remove the handle if it already exists to move it to the front
          handles = handles.filter((h) => h !== currentProductHandle);
          // Add the new handle to the beginning of the array
          handles.unshift(currentProductHandle);
          // Trim the array to the maximum allowed size
          const trimmedHandles = handles.slice(0, MAX_ITEMS);
          saveRecentHandles(trimmedHandles);
        }

        async function displayRecentProducts() {
          const handles = getRecentHandles();

          const fetchPromises = handles.map((handle) =>
            fetch(`${window.Shopify.routes.root}products/${handle}?sections=recently-viewed-product-card`).then(
              async (response) => {
                if (response.ok) {
                  const responseData = await response.json();
                  const html = responseData['recently-viewed-product-card'];
                  const dom = new DOMParser().parseFromString(html, 'text/html');
                  const desktopContent = dom.querySelector('#recently-viewed-product-card-desktop');
                  const mobileContent = dom.querySelector('#recently-viewed-product-card-mobile');
                  const data = {
                    desktop: desktopContent,
                    mobile: mobileContent,
                  };
                  return data;
                }
                return null;
              }
            )
          );

          const products = (await Promise.all(fetchPromises)).filter(Boolean);
          if (products.length > 0) {
            listContainerMobile.innerHTML = '';
            listContainer.innerHTML = '';
            for (const product of products) {
              recentlyViewedContainer.classList.remove('hidden');
              listContainerMobile.appendChild(product.mobile);
              listContainer.appendChild(product.desktop);
            }

            initSwiper();
          } else {
            recentlyViewedContainer.classList.add('hidden');
          }
        }

        function initSwiper() {
          if (swiper) {
            swiper.destroy(true, true);
          }
          swiper = new Swiper(swiperContainer, {
            slidesPerView: 3,
            spaceBetween: 5,
            freeMode: true,
            mousewheel: {
              forceToAxis: true,
            },
          });
        }
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"] && !Shopify.designMode) return;
  try {
    
  window.SearchComponent = function (noResultsText) {
    return {
      open: false,
      noResultsText: noResultsText,
      searchTerm: '',
      searchResults: null,
      querySuggestions: null,
      isPending: false,
      isSuccess: false,
      isError: false,
      error: null,
      init() {
        const button = document.getElementById('header-search-button');
        button.addEventListener('click', () => {
          this.openModal();
        });

        this.$watch('open', (value, oldValue) => {
          if (value === oldValue) return;
          if (value) {
            this.$store.settings.enableBodyScrollLock();
            setTimeout(() => {
              this.$refs.input.focus();
            }, 100);
          } else {
            this.$store.settings.disableBodyScrollLock();
          }
        });
      },
      openModal() {
        this.open = true;
      },
      closeModal() {
        this.open = false;
      },
      debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      },
      onChange() {
        const searchTerm = this.$refs.input.value.trim();
        this.searchTerm = searchTerm;

        if (searchTerm.length === 0) {
          this.querySuggestions = null;
          this.searchResults = null;
          this.isSuccess = false;
          this.isError = false;
          this.isPending = false;
          this.error = null;
          return;
        }

        window.query({
          key: ['searchResults', searchTerm],
          fn: () => this.getSearchResults(searchTerm),
          subscribeFn: (result, unsubscribe) => {
            this.isPending = result.isPending;
            this.isSuccess = result.isSuccess;
            this.isError = result.isError;
            this.error = result.error;

            if (result.isSuccess) {
              const searchResultsContainer = new DOMParser()
                .parseFromString(result.data, 'text/html')
                .querySelector('#shopify-section-predictive-search');
              this.searchResults = searchResultsContainer.querySelector('#search-results').innerHTML;
              this.querySuggestions = searchResultsContainer.querySelector('#query-suggestions').innerHTML;
            }
            if (result.isError) {
              this.error = result.error;
            }
            if (result.isSuccess || result.isError) {
              unsubscribe?.();
            }
          },
        });
      },
      async getSearchResults(searchTerm) {
        const fields = [
          'author',
          'body',
          'product_type',
          'tag',
          'title',
          'variants.barcode',
          'variants.sku',
          'variants.title',
          'vendor',
        ].join(',');
        const params = new URLSearchParams({
          q: searchTerm,
          'resources[type]': 'product,collection,query',
          'resources[options][fields]': fields,
          section_id: 'predictive-search',
        });
        const response = await fetch(`/search/suggest?${params.toString()}`);
        if (!response.ok) {
          throw new Error('Failed to fetch search results');
        }

        const text = await response.text();
        return text;
      },
      onSuggestionClick(term) {
        this.$refs.input.value = term;
        this.onChange();
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  window.StoreLocatorComponent = function (pinUrl) {
    const mapData = {
      markers: [],
      map: null,
      storesData: [],
      markerCluster: null,
    };
    return {
      rawSelectedCountry: null,
      rawSelectedCity: null,
      selectedStore: null,
      init: function () {
        // Parse store data from data attribute
        mapData.storesData = JSON.parse(this.$refs.data.textContent).stores;

        // Load Google Maps API
        this.initializeMap();

        this.$watch('filteredStores', async (filteredStores) => {
          const markers = mapData.markers.filter((marker) =>
            filteredStores.some((store) => store.id === marker.store.id)
          );
          await this.updateMarkers(markers);
          await this.updateBounds(markers);
        });
      },
      initializeMap: async function () {
        if (mapData.map) return;
        const defaultCenter = { lat: 56.2, lng: 9.5 };
        const MapLibrary = await google.maps.importLibrary('maps');
        const MarkerLibrary = await google.maps.importLibrary('marker');
        mapData.map = new MapLibrary.Map(this.$refs.mapContainer, {
          center: defaultCenter,
          zoom: 6,
          styles: this.mapStyles,
          disableDefaultUI: true,
        });

        mapData.storesData.forEach((store) => {
          if (store.latitude && store.longitude) {
            const marker = new MarkerLibrary.Marker({
              position: { lat: parseFloat(store.latitude), lng: parseFloat(store.longitude) },
              icon: {
                url: pinUrl,
              },
            });
            marker.store = store;

            marker.addListener('click', () => {
              this.selectStore(store);
            });
            mapData.markers.push(marker);
          }
        });

        await this.updateMarkers(mapData.markers);
        await this.updateBounds(mapData.markers);
      },
      updateMarkers: async function (markers) {
        const MarkerLibrary = await google.maps.importLibrary('marker');

        if (mapData.markerCluster) {
          mapData.markerCluster.clearMarkers();
          mapData.markerCluster.addMarkers(markers);
        } else {
          mapData.markerCluster = new markerClusterer.MarkerClusterer({
            map: mapData.map,
            markers: markers,
            renderer: {
              render: ({ count, position, markers }) => {
                return new MarkerLibrary.Marker({
                  position: position,
                  icon: {
                    url: pinUrl,
                  },
                  label: {
                    text: count.toString(),
                    fontSize: '1rem',
                    className: 'translate-y-[-150%]',
                    fontWeight: 'bold',
                  },
                });
              },
            },
          });
        }
      },
      updateBounds: async function (markers) {
        const coreLibrary = await google.maps.importLibrary('core');
        // Create an empty LatLngBounds object
        const bounds = new coreLibrary.LatLngBounds();

        // Extend the bounds to include each point
        markers.forEach((marker) => {
          const position = marker.getPosition();
          if (!position) return;
          const point = new coreLibrary.LatLng(position.lat(), position.lng());
          bounds.extend(point);
        });

        mapData.map.fitBounds(bounds);
      },
      selectStore: function (store, scroll = true) {
        this.selectedStore = store;
        const marker = mapData.markers.find((m) => m.store.id === store.id);
        if (marker) {
          mapData.map.setCenter(marker.getPosition());
          mapData.map.setZoom(17);
        }
        if (scroll) {
          const storeListItem = document.querySelector(`[data-store-list-item][data-store-id="${store.id}"]`);
          const distanceFromTop = Math.abs(
            storeListItem.getBoundingClientRect().top - document.documentElement.getBoundingClientRect().top
          );
          window.scrollTo({ top: distanceFromTop - 200, behavior: 'smooth' });
        }
      },

      get selectedCountry() {
        return this.rawSelectedCountry;
      },

      set selectedCountry(country) {
        this.rawSelectedCountry = country;
        this.selectedCity = null;
        this.selectedStore = null;
      },

      get selectedCity() {
        return this.rawSelectedCity;
      },

      set selectedCity(city) {
        this.rawSelectedCity = city;
        this.selectedStore = null;
      },

      get countries() {
        const uniqueCountries = [...new Set(mapData.storesData.map((store) => store.country))];
        return uniqueCountries.filter((c) => c).sort();
      },

      get cities() {
        if (!this.selectedCountry) return [];
        const citiesInCountry = mapData.storesData
          .filter((store) => store.country === this.selectedCountry)
          .map((store) => store.city);
        return [...new Set(citiesInCountry)].filter((c) => c).sort();
      },

      get filteredStores() {
        return mapData.storesData.filter((store) => {
          if (this.selectedCountry && this.selectedCountry !== 'None' && store.country !== this.selectedCountry) {
            return false;
          }
          if (this.selectedCity && this.selectedCity !== 'None' && store.city !== this.selectedCity) {
            return false;
          }
          return true;
        });
      },
      mapStyles: [
        {
          elementType: 'geometry',
          stylers: [
            {
              color: '#f5f5f5',
            },
          ],
        },
        {
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#616161',
            },
          ],
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [
            {
              color: '#f5f5f5',
            },
          ],
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#bdbdbd',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [
            {
              color: '#eeeeee',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#757575',
            },
          ],
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [
            {
              color: '#e5e5e5',
            },
          ],
        },
        {
          featureType: 'poi.park',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [
            {
              color: '#ffffff',
            },
          ],
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#757575',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [
            {
              color: '#dadada',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#616161',
            },
          ],
        },
        {
          featureType: 'road.local',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e',
            },
          ],
        },
        {
          featureType: 'transit.line',
          elementType: 'geometry',
          stylers: [
            {
              color: '#e5e5e5',
            },
          ],
        },
        {
          featureType: 'transit.station',
          elementType: 'geometry',
          stylers: [
            {
              color: '#eeeeee',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [
            {
              color: '#c9c9c9',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e',
            },
          ],
        },
      ],
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  window.WishlistComponent = function () {
    return {
      activeMenuItem: 'wishlist',
    };
  };

  } catch(e) { console.error(e); }
})();
})();
